import { useMyPrivilegesLazyQuery } from "@repo/server-api";
import React, { createContext, useEffect, useContext, useState } from "react";

import type { Privilege } from "@repo/server-api";

const RoleContext = createContext<Privilege>({
	roles: [],
	isMultiContractor: false,
	contractorId: "",
	substituting: [],
});

type RolesProviderProps = {
	children: React.ReactNode;
};

export const RolesProvider: React.FC<RolesProviderProps> = ({ children }) => {
	const [roles, setRoles] = useState<Privilege>({
		roles: [],
		isMultiContractor: false,
		contractorId: "",
		substituting: [],
	});

	const [getMyRules] = useMyPrivilegesLazyQuery({
		fetchPolicy: "no-cache",
		onCompleted(data) {
			if (data?.myPrivileges != null) {
				setRoles(data.myPrivileges as Privilege);
			}
		},
	});

	useEffect(() => {
		void getMyRules();
	}, [getMyRules]);

	return <RoleContext.Provider value={roles}>{children}</RoleContext.Provider>;
};

export const useUserRoles = (): Privilege => {
	return useContext(RoleContext);
};
